export {}

const notifications = document.querySelectorAll(".i-notification")

notifications.forEach((notification) => {
  const closeButtons = notification.querySelectorAll(".i-notification__close")

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener("click", () => notification.remove())
  })
})
